module.exports = __webpack_public_path__ + "media/images/front/recommendation_mailer/spacer-00abdf4b5afc1bc18c42297f51035da5.gif";